import * as u from '@/util/util'
import * as c from '@/util/config'
import * as dict from '@/js/sys/resume/dict'

export const tableOption = {
    border: true,
    index: true,
    indexLabel: '序号',
    indexWidth: 50,
    stripe: true,
    align: 'center',
    searchMenuSpan: 6,
    labelWidth: 120,
    height: '600px',
    calcHeight: 400,
    dialogWidth: 900,
    menuWidth: 100,
    menuAlign: 'center',
    rowKey: "deptId",
    defaultExpandAll: true,
    addBtn: false,
    editBtn: false,
    viewBtn: true,
    delBtn: false,
    column: [
        {
            prop: 'ffpk',
            label: 'ID',
            hide: true,
            viewDisplay: false,
            addDisplay: false,
            editDisplay: false
        },
        {
            prop: 'workouttype',
            label: '招聘类别',
            type: 'select',//type:input/input/select/radio/checkbox/textarea/cascader/date/time/datetime/daterange/timerange/datetimerange/week/month/year/dates/password/switch/tree/number
            minWidth: 50,
            overHidden: true,
            search: true,
            dicData: [
                {label: '校园招聘', value: '校园招聘'},
                {label: '社会招聘', value: '社会招聘'},
            ],
        },
        {
            prop: 'postname',
            label: '职位名称  ',
            type: 'input',
            overHidden: true,
            minWidth: 50,
            search: true,
        },
        {
            prop: 'zpstate',
            label: '招聘状态',
            type: 'select',
            minWidth: 50,
            overHidden: true,
            search: true,
            //dicUrl:"/common/getItem/oper_log_type",
            dicData: [
                {label: '未发布', value: '0'},
                {label: '招聘中', value: '1'},
                {label: '暂停', value: '2'},
                {label: '已取消', value: '3'},
                {label: '已完成', value: '4'},
            ],
        },
        {
            prop: 'deliverytime',
            label: '投递时间',
            type: 'datetime',
            overHidden: true,
            minWidth: 50,
        },
        {
            prop: 'a0101',
            label: '姓名',
            hide: u.buttonPermissionsCheck("SYS-RESUME-NAME"),
        },
        {
            prop: 'a0102',
            label: '性别',
            hide: true,
            type: 'radio',
            dicData: [
                {label: '男', value: '1'},
                {label: '女', value: '2'},
            ],
        },
        {
            prop: 'originplace',
            label: '籍贯',
            hide: true,
        },
        {
            prop: 'age',
            label: '年龄',
            hide: true,
        },
        {
            prop: 'a0118',
            label: '联系电话',
            hide: true,
        },
        {
            prop: 'email',
            label: '邮箱',
            hide: true,
        },
        {
            prop: 'a0124',
            label: '最高学历',
            hide: true,
            type: 'select',
            // 字典参数   props 匹配后台字段
            props: {
                value: "BM0000",
                label: "MC0000",
            },
            dicUrl:'/zp-resume/get-bm-xl',
            //dicData: dict.a0124,
        },
        {
            prop: 'univiersity',
            label: '毕业院校',
            hide: true,
        },
        {
            prop: 'zpresumeinfo003',
            label: '院校所属省份',
            hide: true,
            type: 'select',
            // 字典参数   props 匹配后台字段
            props: {
                value: "BM0000",
                label: "MC0000",
            },
            dicUrl:'/zp-resume/get-bm-wryxsf',
        },
        {
            prop: 'trade',
            label: '专业',
            hide: true,
        },
        {
            prop: 'a0202Array',
            label: '期望工作地点',
            hide: true,
            type: 'select',
            multiple: true,   //将可选变为多选
            // 字典参数   props 匹配后台字段
            props: {
                value: "BM0000",
                label: "MC0000",
            },
            dicUrl:'/zp-resume/get-bm-qwfzdd',
        },
        {
            prop: 'zpresumeinfo001',
            label: '是否服从调剂',
            type: 'radio',
            hide: true,
            dicData: dict.zpresumeinfo001,
        },
        {
            prop: 'zpresumeinfo002',
            label: '高考成绩',
            hide: true,
        },
        {
            prop: 'lystatus',
            label: '录用状态',
            type: 'select',
            dicData: [
                {label: '待录用', value: '00'},
                {label: '其他', value: '01'},
            ],
        },
    ]
}

